import { useEffect, useState } from 'react';
import { IdConsole } from '../../clients';
import { constants } from './definitions';
import {
  UseFeatureFlagsOptions,
  UseFeatureFlagsResult,
} from './definitions/types';
import logger from '../../../lib/logger';

const useFeatureFlag = ({
  featureFlagKey,
}: UseFeatureFlagsOptions): UseFeatureFlagsResult => {
  const [featureFlag, updateFeatureFlag] = useState(
    constants.featureFlagDefaultState,
  );

  useEffect(() => {
    (async (): Promise<void> => {
      try {
        const response = await IdConsole.getFeatureFlags();
        const isEnabled = !!response.result.includes(featureFlagKey);

        updateFeatureFlag({
          loading: false,
          hasError: false,
          isEnabled,
        });
      } catch (error) {
        updateFeatureFlag({
          loading: false,
          hasError: true,
          isEnabled: false,
        });

        logger.error(`${constants.LOG_PREFIX}::${JSON.stringify(error)}`);
      }
    })();
  }, []);

  return featureFlag;
};

export default useFeatureFlag;
